import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <CommentsSection />
        <FeaturesSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <RankingSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <MediaSection />
        <IndexSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}